export enum TableName {
  OdeHistory,
  PaymentsTab,
  CrrHistory
}
